import BreadcrumbLink from "components/elements/Breadcrumbs/BreadcrumbLink";
import { UrlObject } from "url";

export default function BreadcrumbDefault(p: {
  segments: string[];
  params: string[];
  href: UrlObject;
}) {
  const text =
    p.params[0] || p.segments[0][0]?.toUpperCase() + p.segments[0].slice(1);

  return <BreadcrumbLink href={p.href}>{text}</BreadcrumbLink>;
}
